import { Card } from '@/components/ui/card.tsx';
import { cn } from 'cn';
import { ReactNode } from 'react';
import { pageContentClassName } from './pageContentClass';

export interface GridPageProps {
  title?: string;
  action?: ReactNode;
  /** Блок над таблицей: фильтры, формы создания и т.п. */
  subheader?: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * Страница со AG Grid: заголовок и subheader фиксированы по высоте,
 * таблица занимает оставшееся место и скроллится внутри.
 */
export function GridPage({ title, action, subheader, children, className }: GridPageProps) {
  return (
    <div className={cn(pageContentClassName, 'grid-page', className)}>
      {title || action ? (
        <div className="mb-3 flex shrink-0 items-center justify-between gap-3">
          {title ? <h1 className="text-xl font-semibold tracking-tight">{title}</h1> : <span />}
          {action}
        </div>
      ) : null}

      {subheader ? <div className="mb-3 flex shrink-0 flex-col gap-3">{subheader}</div> : null}

      <Card
        size="sm"
        className="mb-0 flex min-h-0 flex-1 flex-col overflow-hidden p-2 shadow-sm sm:p-3"
      >
        <div className="flex min-h-0 flex-1 flex-col">{children}</div>
      </Card>
    </div>
  );
}
